import audio from '../../../../assets/audio/kids-tracks/Text1.mp3';

export const step2coffeeShop = {
    id: 2,
    title: 'Ahoj!',
    taskText: `
        <p>
            Ahoj, jak se jmenuješ? Já jsem Míša, kocour, který má tohle město prošmejděný horem dolem. Rád hledám nová místa a řeším záhady.
        </p>
        <p>
            Nyní stojíme kousek od kostela na Zelené hoře, ale moc zelené to tu teda není. Ještě před pár roky byla na Zelené hoře spousta stromů. 
            Z toho důvodu jsem si myslel, že je to tam pojmenované podle nich, ale ty jsou už nějakou dobu fuč.
        </p>
        <p>    
            Tak že by to bylo kvůli barvě toho kostela? Ale ani ten se mi nezdá zelený. Prý ho postavil někdo slavný, 
            ale tomu já moc nerozumím. My kočky na slávu moc nedáme. Mimo to se ti musím přiznat, že je tu taky hodně duchů, 
            které vidíme jen my kočky. Nevím proč jsou právě tady, ale zřejmě je to tu nějaké kouzelné.
        </p>
        <p>
            Říkal jsem si, pokud máš čas, nechtěl bys mi pomoct přijít na to, jak je to s tou barvou? Myslím si totiž, 
            že to nebude jen tak 😉 Máš čas? Tak to je super. Kde začneme? Možná támhle na tom rozcestí. Je tam dobrý výhled 
            na ten zajímavý most s těmi zvláštními kamennými lidmi. Ten tu určitě taky nestojí jen tak.
        </p>
    `,
    cipher: {
        text: 'Vydejte se dále na nejbližší rozcestí s výhledem na kamenný most se sochami.',
        label: 'Úkol',
    },
    audio: audio,
    continueButtonText: 'Jsme u rozcestí',
    points: false,
};
